module.exports = __webpack_public_path__ + "img/provided-by-logo.fe621b23.svg";